var c = 0;
function t(o) {
  o ? (c || document.body.classList.add("van-toast--unclickable"), c++) : (c--, c || document.body.classList.remove("van-toast--unclickable"));
}
export { t as lockClick };
